import { render, staticRenderFns } from "./AiMailsView.vue?vue&type=template&id=d79860b8"
import script from "./AiMailsView.vue?vue&type=script&lang=js"
export * from "./AiMailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports